import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the PaypalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

declare var paypal: any;

@IonicPage()
@Component({
  selector: 'page-paypal',
  templateUrl: 'paypal.html',
})
export class PaypalPage {

  public PlanID;
  public Price
  public Desc;
  public Res = 0;


  constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams) {
    this.PlanID = this.navParams.get('PlanID');
    this.Price = this.navParams.get('Price');
    this.Desc = this.navParams.get('Desc');
    //  console.log(this.Desc + ' - €' + this.Price);
  }

  ionViewDidLoad() {
    //  console.log(this.Price)
    this.payButtonHandler(this.Price, this.Desc, this.PlanID, this);
    // this.PayTest(this.Price);
  }

  PayTest(pri) {

    const pr = pri
    console.log(pr)
    paypal.Buttons({
      createOrder: function (data, actions) {
        // This function sets up the details of the transaction, including the amount and line item details.
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: pr
            }
          }]
        });
      },
      onApprove: function (data, actions) {
        // This function captures the funds from the transaction.
        return actions.order.capture().then(function (details) {
          // This function shows a transaction success message to your buyer.
          alert('Transaction completed by ' + details.payer.name.given_name);
        });
      }
    }).render('#paypal-button-container');
    //This function displays Smart Payment Buttons on your web page.
  }

  payButtonHandler(price, desc, ID, th) {
    const _this = th
    // const pr = price
    // const ds = desc
    try {


      paypal.Buttons({
        //Paypal TEST
         //env: 'sandbox',

        //paypal Produzione 
        env: 'production',

        client: {
          //Paypal TEST LUCA
          // sandbox: 'AQRpqaxD8fH4HO1KOb07uvXfGMc9O6NjAv8DFnz0UgIB33_K0nCJ1j-3OMsajZyEbSn5j8TCDYSBPsCV',
            //Paypal TEST GIOVANNI
          // sandbox: 'Acvl_YgsZIn-DYWLqhcnC2_dkEZDVhbq30yryuCYxSuml7_P4pg6nHMgqd9o7sxl0Qoj9Krqs5m_E7E2',

          //paypal Produzione GIOVANNI
          production: 'AXLDJOg9UUtAcb7K-06_OlZC2ogx3Et3bKRJFbRPxKfB3fZ8YRu7f8aFQ14XChKcKAeUaY6DEQ_0Md5c'
        },
        // Set up the transaction
        createOrder: function (data, actions) {
          return actions.order.create({
            description: desc,

            purchase_units: [{

              description: desc,
              amount: {
                currency_code: "EUR",
                value: price,
                // breakdown: {
                //   item_total: { currency_code: "EUR", value: "100.00" },
                //   tax_total: { currency_code: "EUR", value: "10.00" }
                // }
                Description: desc


              },
              // items: [{ name: this.Desc, tax: { currency_code: "EUR", value: "10.00" }, quantity: "1", unit_amount: { currency_code: "EUR", value: "100.00" } }]
            }],
            // redirect_urls: {
            //   return_url: 'http://www.pawelbiernacki.net/PawelBiernackiSklep/Success',
            //   cancel_url: 'http://www.pawelbiernacki.net/PawelBiernackiSklep/Cancel'
            // }
          });
        },

        // Finalize the transaction
        onApprove: function (data, actions) {
          return actions.order.capture()
            .then(function (details) {
              console.log(details);
              // Show a success message to the buyer
              alert('Grazie ' + details.payer.name.given_name + '!' + ' Pagamento avvenuto con successo per: ' + desc + ' a ' + price + '€');
              //TODO: Chiudere la finestra con il risutato Ok in modo da aggiornare il DB

              _this.close(ID);
            })
            .catch(err => {
              console.log(err);
            })
        }
        ,
        onError: function (error) {
          console.log(error);
        },
        onCancel: (data, actions) => {
          console.log(data, actions);
          // actions.redirect();
        }
      }).render('#paypal-button');

      console.log('fine')

    } catch (error) {
      console.log(error);
    }

  }

  close(Res) {

    try {
      this.Res = Res;
      console.log(this.Res);
      this.viewCtrl.dismiss({ Result: this.Res });
    } catch (error) {
      console.log(error);
    }


  }

  ionViewWillLeave() {

    console.log('chiudo finestra');

  }


}



// WEBPACK FOOTER //
// ./src/pages/paypal/paypal.ts